import type { DashboardSnapshot } from "../shared/types";

export class ApiRequestError extends Error {
  constructor(message: string, readonly status: number, readonly retryAfterSeconds: number | null) {
    super(message);
    this.name = "ApiRequestError";
  }
}

async function request<T>(path: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(path, { signal, headers: { Accept: "application/json" } });
  if (!response.ok) {
    const body = await response.json().catch(() => ({})) as { error?: string };
    const retryAfter = Number(response.headers.get("Retry-After"));
    throw new ApiRequestError(
      body.error ?? `Request failed with status ${response.status}`,
      response.status,
      Number.isFinite(retryAfter) && retryAfter > 0 ? Math.min(120, retryAfter) : null,
    );
  }
  return response.json() as Promise<T>;
}

export function getDashboard(signal?: AbortSignal): Promise<DashboardSnapshot> {
  return request("/api/dashboard?range=30d", signal);
}
